import Dashboard from "../views/Dashboard.vue";
import AddRobot from "../views/Robot/AddRobot.vue";
import AddBroker from "../views/Robot/Broker/AddBroker.vue";
import UpdateBroker from "../views/Robot/Broker/UpdateBroker.vue";
import UpdateRobot from "../views/Robot/UpdateRobot.vue";
import RobotList from "../views/Robot/RobotList.vue";
import RobotDetails from "../views/Robot/RobotDetails.vue";
import Profile from "../views/Profile/Profile.vue";
import Subscription from "../views/Subscription.vue";
import Order from "../views/Order.vue";
import Bonus from "../views/Bonus.vue";
import Disbursement from "../views/Disbursement.vue";
import UpdateProfile from "../views/Profile/UpdateProfile.vue";
import ChangePassword from "../views/Profile/ChangePassword.vue";
import Bank from "../views/Bank/Bank.vue";
import AddBank from "../views/Bank/AddBank.vue";
import auth from "../middleware/auth";
import vendor_notcomplete from "../middleware/vendor_notcomplete";

export default [
    {
        path: "/",
        name: "Dashboard",
        component: Dashboard,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Dashboard",
        }
    },
    {
        path: "/add-robot",
        name: "AddRobot",
        component: AddRobot,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Add Robot",
        }
    },
    {
        path: "/update-robot/:id",
        name: "UpdateRobot",
        component: UpdateRobot,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Edit Robot",
        }
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Profile",
        }
    },
    {
        path: "/profile/update/:id",
        name: "UpdateProfile",
        component: UpdateProfile,
        meta: {
            middleware: [auth],
            title: "Edit Profile",
        }
    },
    {
        path: "/profile/change-password/:id",
        name: "ChangePassword",
        component: ChangePassword,
        meta: {
            middleware: [auth,  vendor_notcomplete],
            title: "Change Password",
        }
    },
    {
        path: "/robot",
        name: "RobotList",
        component: RobotList,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Robot List",
        }
    },
    {
        path: "/robot/:id",
        name: "RobotDetails",
        component: RobotDetails,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Robot Details",
        }
    },
    {
        path: "/subscription",
        name: "Subscription",
        component: Subscription,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Subscription",
        }
    },
    {
        path: "/bonus",
        name: "Bonus",
        component: Bonus,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Bonus",
        }
    },
    {
        path: "/order",
        name: "Order",
        component: Order,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Order",
        }
    },
    {
        path: "/disbursement",
        name: "Disbursement",
        component: Disbursement,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Disbursement",
        }
    },
    {
        path: "/bank",
        name: "Bank",
        component: Bank,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Bank",
        }
    },
    {
        path: "/add-broker/:id",
        name: "AddBroker",
        component: AddBroker,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Add Broker",
        }
    },
    {
        path: "/update-broker/:id",
        name: "UpdateBroker",
        component: UpdateBroker,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Edit Broker",
        }
    },
    {
        path: "/add-bank-account",
        name: "AddBank",
        component: AddBank,
        meta: {
            middleware: [auth, vendor_notcomplete],
            title: "Add Bank",
        }
    },
]
